"use client";

import React, { useActionState, useEffect, useState } from "react";
import { CMSData } from "@/cms/models";
import { ApplicationFraction } from "@/utils/gql/graphql";
import FormLayout from "../inputs/FormLayout";
import StoreSelect from "../inputs/StoreSelect";
import TextAreaInput from "../inputs/TextAreaInput";
import TextInput from "../inputs/TextInput";
import { submitContactForm } from "@/actions/contact-form";
import { CONTACT_INITIAL_STATE } from "@/services/form.service";
import ConfirmModal from "../ConfirmModal";

export interface ContactFormProps {
  config: {
    cmsData: CMSData;
    app: ApplicationFraction;
  };
}

const ContactForm: React.FC<ContactFormProps> = ({ config }) => {
 
  const [isOpen, setIsOpen] = useState(false);
  const [formState, formAction, isPending] = useActionState(
    submitContactForm,
    CONTACT_INITIAL_STATE
  );

  useEffect(() => {
    setIsOpen(formState.isSuccess ?? false);
  }, [formState]);

  const { firstName, lastName, address, zip, city, phone, email, message } =
    formState?.data || {};

  return (
    <div className="flex w-full flex-1">
      <ConfirmModal
        app={config.app}
        description="Du kan altid kontakte os på:"
        title="Tak for din henvendelse"
        setOpen={(isOpen) => setIsOpen(isOpen)}
        isOpen={isOpen}
      />

      <FormLayout
        submitLabel="Send"
        isPending={isPending}
        formAction={formAction}
      >
        <StoreSelect
          cmsData={config.cmsData}
          label="Vælg butik"
          name="resourceGroupId"
          stores={config.app.stores!}
        />
        <TextInput
          cmsData={config.cmsData}
          name="firstName"
          label="Fornavn"
          defaultValue={firstName}
          errors={formState?.zodErrors?.firstName}
          required={config.cmsData?.forms.nameRequired}
        />
        <TextInput
          cmsData={config.cmsData}
          name="lastName"
          label="Efternavn"
          defaultValue={lastName}
          errors={formState?.zodErrors?.lastName}
          required={config.cmsData?.forms.nameRequired}
        />
        <TextInput
          cmsData={config.cmsData}
          className="col-span-6"
          name="address"
          label="Adresse"
          defaultValue={address}
          errors={formState?.zodErrors?.address}
          required={config.cmsData?.forms.addressRequired}
        />
        <TextInput
          cmsData={config.cmsData}
          className="col-span-2"
          name="zip"
          label="Postnr"
          defaultValue={zip}
          errors={formState?.zodErrors?.zip}
          required={config.cmsData?.forms.zipRequired}
        />
        <TextInput
          cmsData={config.cmsData}
          className="col-span-4"
          name="city"
          label="By"
          defaultValue={city}
          errors={formState?.zodErrors?.city}
          required={config.cmsData?.forms.cityRequired}
        />
        <TextInput
          cmsData={config.cmsData}
          className="col-span-3"
          name="phone"
          label="Telefonnummer"
          defaultValue={phone}
          errors={formState?.zodErrors?.phone}
          required={config.cmsData?.forms.phoneRequired}
        />
        <TextInput
          cmsData={config.cmsData}
          className="col-span-3"
          name="email"
          label="E-mail"
          defaultValue={email}
          errors={formState?.zodErrors?.email}
          required={config.cmsData?.forms.emailRequired}
        />
        <TextAreaInput
          cmsData={config.cmsData}
          name="message"
          label="Besked"
          defaultValue={message}
          errors={formState?.zodErrors?.message}
          required={false}
        />
      </FormLayout>
    </div>
  );
};

export default ContactForm;
